import { DrawerBody, Drawer, DrawerContent, DrawerCloseButton, ModalOverlay } from "@chakra-ui/modal";
import { useDarkmode } from "hooks/useTheme";

function Dialog({isOpen, onClose, cancelCloseByOverlay, children}) {
    const {darkmode} = useDarkmode();

    return (
        <Drawer isOpen={isOpen} onClose={onClose} closeOnOverlayClick={!cancelCloseByOverlay} trapFocus={false} useInert={false} placement="top">
            <ModalOverlay bg={darkmode ? '#A3AED080' : '#2B367480'} backdropFilter='blur(3px)' zIndex={21}/>
            <DrawerContent containerProps={{zIndex: 22}} className="!relative !m-auto py-4 px-6 !w-[340px] md:!w-[540px] rounded-2xl bg-white dark:text-white shadow-[-20px_17px_40px_4px_rgba(112,_144,_176,_0.18)] dark:bg-background-900 dark:shadow-[-22px_32px_51px_4px_#0B1437]">
                <DrawerCloseButton className="absolute right-6 top-4 text-sm p-2 text-gray-900 dark:text-white" />
                <DrawerBody>
                    {children}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

export default Dialog;
